/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as LoginRouteImport } from "./routes/login";
import { Route as AppRouteImport } from "./routes/_app";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as AppTodayRouteImport } from "./routes/_app/today";
import { Route as AppTablesRouteImport } from "./routes/_app/tables";
import { Route as AppSettingsRouteImport } from "./routes/_app/settings";
import { Route as AppSessionControlRouteImport } from "./routes/_app/session-control";
import { Route as AppScreenQueueRouteImport } from "./routes/_app/screen-queue";
import { Route as AppOrdersRouteImport } from "./routes/_app/orders";
import { Route as AppModerationRouteImport } from "./routes/_app/moderation";
import { Route as AppIncidentsRouteImport } from "./routes/_app/incidents";
import { Route as AppGiftsRouteImport } from "./routes/_app/gifts";
import { Route as AppFloorRouteImport } from "./routes/_app/floor";
import { Route as AppCashierRouteImport } from "./routes/_app/cashier";
import { Route as AppTablesTableSessionIdRouteImport } from "./routes/_app/tables.$tableSessionId";
import { Route as AppOrdersOrderIdRouteImport } from "./routes/_app/orders.$orderId";
import { Route as AppModerationReportIdRouteImport } from "./routes/_app/moderation.$reportId";
import { Route as AppGiftsGiftIdRouteImport } from "./routes/_app/gifts.$giftId";

const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any);
const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const AppTodayRoute = AppTodayRouteImport.update({
  id: "/today",
  path: "/today",
  getParentRoute: () => AppRoute,
} as any);
const AppTablesRoute = AppTablesRouteImport.update({
  id: "/tables",
  path: "/tables",
  getParentRoute: () => AppRoute,
} as any);
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AppRoute,
} as any);
const AppSessionControlRoute = AppSessionControlRouteImport.update({
  id: "/session-control",
  path: "/session-control",
  getParentRoute: () => AppRoute,
} as any);
const AppScreenQueueRoute = AppScreenQueueRouteImport.update({
  id: "/screen-queue",
  path: "/screen-queue",
  getParentRoute: () => AppRoute,
} as any);
const AppOrdersRoute = AppOrdersRouteImport.update({
  id: "/orders",
  path: "/orders",
  getParentRoute: () => AppRoute,
} as any);
const AppModerationRoute = AppModerationRouteImport.update({
  id: "/moderation",
  path: "/moderation",
  getParentRoute: () => AppRoute,
} as any);
const AppIncidentsRoute = AppIncidentsRouteImport.update({
  id: "/incidents",
  path: "/incidents",
  getParentRoute: () => AppRoute,
} as any);
const AppGiftsRoute = AppGiftsRouteImport.update({
  id: "/gifts",
  path: "/gifts",
  getParentRoute: () => AppRoute,
} as any);
const AppFloorRoute = AppFloorRouteImport.update({
  id: "/floor",
  path: "/floor",
  getParentRoute: () => AppRoute,
} as any);
const AppCashierRoute = AppCashierRouteImport.update({
  id: "/cashier",
  path: "/cashier",
  getParentRoute: () => AppRoute,
} as any);
const AppTablesTableSessionIdRoute = AppTablesTableSessionIdRouteImport.update({
  id: "/$tableSessionId",
  path: "/$tableSessionId",
  getParentRoute: () => AppTablesRoute,
} as any);
const AppOrdersOrderIdRoute = AppOrdersOrderIdRouteImport.update({
  id: "/$orderId",
  path: "/$orderId",
  getParentRoute: () => AppOrdersRoute,
} as any);
const AppModerationReportIdRoute = AppModerationReportIdRouteImport.update({
  id: "/$reportId",
  path: "/$reportId",
  getParentRoute: () => AppModerationRoute,
} as any);
const AppGiftsGiftIdRoute = AppGiftsGiftIdRouteImport.update({
  id: "/$giftId",
  path: "/$giftId",
  getParentRoute: () => AppGiftsRoute,
} as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/login": typeof LoginRoute;
  "/cashier": typeof AppCashierRoute;
  "/floor": typeof AppFloorRoute;
  "/gifts": typeof AppGiftsRouteWithChildren;
  "/incidents": typeof AppIncidentsRoute;
  "/moderation": typeof AppModerationRouteWithChildren;
  "/orders": typeof AppOrdersRouteWithChildren;
  "/screen-queue": typeof AppScreenQueueRoute;
  "/session-control": typeof AppSessionControlRoute;
  "/settings": typeof AppSettingsRoute;
  "/tables": typeof AppTablesRouteWithChildren;
  "/today": typeof AppTodayRoute;
  "/gifts/$giftId": typeof AppGiftsGiftIdRoute;
  "/moderation/$reportId": typeof AppModerationReportIdRoute;
  "/orders/$orderId": typeof AppOrdersOrderIdRoute;
  "/tables/$tableSessionId": typeof AppTablesTableSessionIdRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/login": typeof LoginRoute;
  "/cashier": typeof AppCashierRoute;
  "/floor": typeof AppFloorRoute;
  "/gifts": typeof AppGiftsRouteWithChildren;
  "/incidents": typeof AppIncidentsRoute;
  "/moderation": typeof AppModerationRouteWithChildren;
  "/orders": typeof AppOrdersRouteWithChildren;
  "/screen-queue": typeof AppScreenQueueRoute;
  "/session-control": typeof AppSessionControlRoute;
  "/settings": typeof AppSettingsRoute;
  "/tables": typeof AppTablesRouteWithChildren;
  "/today": typeof AppTodayRoute;
  "/gifts/$giftId": typeof AppGiftsGiftIdRoute;
  "/moderation/$reportId": typeof AppModerationReportIdRoute;
  "/orders/$orderId": typeof AppOrdersOrderIdRoute;
  "/tables/$tableSessionId": typeof AppTablesTableSessionIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/_app": typeof AppRouteWithChildren;
  "/login": typeof LoginRoute;
  "/_app/cashier": typeof AppCashierRoute;
  "/_app/floor": typeof AppFloorRoute;
  "/_app/gifts": typeof AppGiftsRouteWithChildren;
  "/_app/incidents": typeof AppIncidentsRoute;
  "/_app/moderation": typeof AppModerationRouteWithChildren;
  "/_app/orders": typeof AppOrdersRouteWithChildren;
  "/_app/screen-queue": typeof AppScreenQueueRoute;
  "/_app/session-control": typeof AppSessionControlRoute;
  "/_app/settings": typeof AppSettingsRoute;
  "/_app/tables": typeof AppTablesRouteWithChildren;
  "/_app/today": typeof AppTodayRoute;
  "/_app/gifts/$giftId": typeof AppGiftsGiftIdRoute;
  "/_app/moderation/$reportId": typeof AppModerationReportIdRoute;
  "/_app/orders/$orderId": typeof AppOrdersOrderIdRoute;
  "/_app/tables/$tableSessionId": typeof AppTablesTableSessionIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/login"
    | "/cashier"
    | "/floor"
    | "/gifts"
    | "/incidents"
    | "/moderation"
    | "/orders"
    | "/screen-queue"
    | "/session-control"
    | "/settings"
    | "/tables"
    | "/today"
    | "/gifts/$giftId"
    | "/moderation/$reportId"
    | "/orders/$orderId"
    | "/tables/$tableSessionId";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/login"
    | "/cashier"
    | "/floor"
    | "/gifts"
    | "/incidents"
    | "/moderation"
    | "/orders"
    | "/screen-queue"
    | "/session-control"
    | "/settings"
    | "/tables"
    | "/today"
    | "/gifts/$giftId"
    | "/moderation/$reportId"
    | "/orders/$orderId"
    | "/tables/$tableSessionId";
  id:
    | "__root__"
    | "/"
    | "/_app"
    | "/login"
    | "/_app/cashier"
    | "/_app/floor"
    | "/_app/gifts"
    | "/_app/incidents"
    | "/_app/moderation"
    | "/_app/orders"
    | "/_app/screen-queue"
    | "/_app/session-control"
    | "/_app/settings"
    | "/_app/tables"
    | "/_app/today"
    | "/_app/gifts/$giftId"
    | "/_app/moderation/$reportId"
    | "/_app/orders/$orderId"
    | "/_app/tables/$tableSessionId";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AppRoute: typeof AppRouteWithChildren;
  LoginRoute: typeof LoginRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/login": {
      id: "/login";
      path: "/login";
      fullPath: "/login";
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_app": {
      id: "/_app";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AppRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_app/today": {
      id: "/_app/today";
      path: "/today";
      fullPath: "/today";
      preLoaderRoute: typeof AppTodayRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/tables": {
      id: "/_app/tables";
      path: "/tables";
      fullPath: "/tables";
      preLoaderRoute: typeof AppTablesRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/settings": {
      id: "/_app/settings";
      path: "/settings";
      fullPath: "/settings";
      preLoaderRoute: typeof AppSettingsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/session-control": {
      id: "/_app/session-control";
      path: "/session-control";
      fullPath: "/session-control";
      preLoaderRoute: typeof AppSessionControlRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/screen-queue": {
      id: "/_app/screen-queue";
      path: "/screen-queue";
      fullPath: "/screen-queue";
      preLoaderRoute: typeof AppScreenQueueRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/orders": {
      id: "/_app/orders";
      path: "/orders";
      fullPath: "/orders";
      preLoaderRoute: typeof AppOrdersRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/moderation": {
      id: "/_app/moderation";
      path: "/moderation";
      fullPath: "/moderation";
      preLoaderRoute: typeof AppModerationRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/incidents": {
      id: "/_app/incidents";
      path: "/incidents";
      fullPath: "/incidents";
      preLoaderRoute: typeof AppIncidentsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/gifts": {
      id: "/_app/gifts";
      path: "/gifts";
      fullPath: "/gifts";
      preLoaderRoute: typeof AppGiftsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/floor": {
      id: "/_app/floor";
      path: "/floor";
      fullPath: "/floor";
      preLoaderRoute: typeof AppFloorRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/cashier": {
      id: "/_app/cashier";
      path: "/cashier";
      fullPath: "/cashier";
      preLoaderRoute: typeof AppCashierRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/tables/$tableSessionId": {
      id: "/_app/tables/$tableSessionId";
      path: "/$tableSessionId";
      fullPath: "/tables/$tableSessionId";
      preLoaderRoute: typeof AppTablesTableSessionIdRouteImport;
      parentRoute: typeof AppTablesRoute;
    };
    "/_app/orders/$orderId": {
      id: "/_app/orders/$orderId";
      path: "/$orderId";
      fullPath: "/orders/$orderId";
      preLoaderRoute: typeof AppOrdersOrderIdRouteImport;
      parentRoute: typeof AppOrdersRoute;
    };
    "/_app/moderation/$reportId": {
      id: "/_app/moderation/$reportId";
      path: "/$reportId";
      fullPath: "/moderation/$reportId";
      preLoaderRoute: typeof AppModerationReportIdRouteImport;
      parentRoute: typeof AppModerationRoute;
    };
    "/_app/gifts/$giftId": {
      id: "/_app/gifts/$giftId";
      path: "/$giftId";
      fullPath: "/gifts/$giftId";
      preLoaderRoute: typeof AppGiftsGiftIdRouteImport;
      parentRoute: typeof AppGiftsRoute;
    };
  }
}

interface AppGiftsRouteChildren {
  AppGiftsGiftIdRoute: typeof AppGiftsGiftIdRoute;
}

const AppGiftsRouteChildren: AppGiftsRouteChildren = {
  AppGiftsGiftIdRoute: AppGiftsGiftIdRoute,
};

const AppGiftsRouteWithChildren = AppGiftsRoute._addFileChildren(
  AppGiftsRouteChildren,
);

interface AppModerationRouteChildren {
  AppModerationReportIdRoute: typeof AppModerationReportIdRoute;
}

const AppModerationRouteChildren: AppModerationRouteChildren = {
  AppModerationReportIdRoute: AppModerationReportIdRoute,
};

const AppModerationRouteWithChildren = AppModerationRoute._addFileChildren(
  AppModerationRouteChildren,
);

interface AppOrdersRouteChildren {
  AppOrdersOrderIdRoute: typeof AppOrdersOrderIdRoute;
}

const AppOrdersRouteChildren: AppOrdersRouteChildren = {
  AppOrdersOrderIdRoute: AppOrdersOrderIdRoute,
};

const AppOrdersRouteWithChildren = AppOrdersRoute._addFileChildren(
  AppOrdersRouteChildren,
);

interface AppTablesRouteChildren {
  AppTablesTableSessionIdRoute: typeof AppTablesTableSessionIdRoute;
}

const AppTablesRouteChildren: AppTablesRouteChildren = {
  AppTablesTableSessionIdRoute: AppTablesTableSessionIdRoute,
};

const AppTablesRouteWithChildren = AppTablesRoute._addFileChildren(
  AppTablesRouteChildren,
);

interface AppRouteChildren {
  AppCashierRoute: typeof AppCashierRoute;
  AppFloorRoute: typeof AppFloorRoute;
  AppGiftsRoute: typeof AppGiftsRouteWithChildren;
  AppIncidentsRoute: typeof AppIncidentsRoute;
  AppModerationRoute: typeof AppModerationRouteWithChildren;
  AppOrdersRoute: typeof AppOrdersRouteWithChildren;
  AppScreenQueueRoute: typeof AppScreenQueueRoute;
  AppSessionControlRoute: typeof AppSessionControlRoute;
  AppSettingsRoute: typeof AppSettingsRoute;
  AppTablesRoute: typeof AppTablesRouteWithChildren;
  AppTodayRoute: typeof AppTodayRoute;
}

const AppRouteChildren: AppRouteChildren = {
  AppCashierRoute: AppCashierRoute,
  AppFloorRoute: AppFloorRoute,
  AppGiftsRoute: AppGiftsRouteWithChildren,
  AppIncidentsRoute: AppIncidentsRoute,
  AppModerationRoute: AppModerationRouteWithChildren,
  AppOrdersRoute: AppOrdersRouteWithChildren,
  AppScreenQueueRoute: AppScreenQueueRoute,
  AppSessionControlRoute: AppSessionControlRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppTablesRoute: AppTablesRouteWithChildren,
  AppTodayRoute: AppTodayRoute,
};

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
